import "../../Assets/Css/admin_style.css";
import Logo from "../../Assets/Images/logo.png";
import { useNavigate } from "react-router-dom";

const TopNavbar = () => {
  const navigate = useNavigate();

  const token = sessionStorage.getItem("admin_token");

  const handleLogout = () => {
    sessionStorage.removeItem("admin_token");
    navigate("/admin/login");
  };

  return (
    <div className="top-navbar py-4 d-flex justify-content-between align-items-center px-4">
      <div className="logo-container">
        <div
          className="navbar-brand text-dark fw-bold"
          style={{ cursor: "pointer" }}
          onClick={() => navigate("/")}>
          <img src={Logo} alt="Logo" className="logo" />
        </div>
      </div>

      {token && (
        <div className="nav-actions">
          <button className="btn btn-sm btn-danger" onClick={handleLogout}>
            Logout
          </button>
        </div>
      )}
    </div>
  );
};

export default TopNavbar;
